import Vue from 'global-vue'

export default class {

    run(){

    }
}